import { formatDecimal } from '../../util/format-decimal';
export const generateIncomeRanges = tiers => {
  const incomeRanges = {};
  for (let i = 0; i < tiers.length; i++) {
    const value = tiers[i] === null ? 0 : tiers[i];
    const valueNextIndex = tiers[i + 1] === null ? 0 : tiers[i + 1];
    if (i === 0) {
      incomeRanges[`Tier${i}`] = `\$${formatDecimal(value, {
        separator: ','
      })} or less`;
      incomeRanges[`Tier${i + 1}`] = `\$${formatDecimal(value + 1, {
        separator: ','
      })} - \$${formatDecimal(valueNextIndex, {
        separator: ','
      })}`;
    } else if (i === tiers.length - 1) {
      incomeRanges[`Tier${i + 1}`] = `\$${formatDecimal(value + 1, {
        separator: ','
      })} or more`;
    } else {
      incomeRanges[`Tier${i + 1}`] = `\$${formatDecimal(value + 1, {
        separator: ','
      })} - \$${formatDecimal(valueNextIndex, {
        separator: ','
      })}`;
    }
  }
  incomeRanges.NoRebate = "Don't apply rebate";
  return incomeRanges;
};